import React from 'react'

const Besmele = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      baseProfile="tiny"
      x="0px"
      y="0px"
      className="w-full max-w-xl"
      fill="currentColor"
      viewBox="-8584 0 17168 3372"
      id="svg2"
    >
      <path
        d="M7726 2346c0,33 -87,96 -261,186 -165,86 -261,129 -289,129 24,-55 106,-124 245,-209 135,-82 234,-127 298,-134 5,3 7,12 7,28z"
        id="path2283"
      />
      <path
        d="M7668 2149c0,14 -4,36 -13,66 -11,35 -21,53 -30,53 -14,0 -39,-12 -77,-36 -37,-24 -57,-41 -59,-52l0 0c0,-18 6,-40 17,-65 12,-30 26,-45 40,-45 10,0 32,11 68,33 36,23 54,38 54,46z"
        id="path2285"
      />
      <path
        d="M7140 1316c0,8 -7,28 -22,61 -19,47 -53,80 -102,96 -48,17 -96,33 -143,48l-4 -7c0,-17 22,-39 64,-66 35,-22 65,-38 90,-47 -26,-6 -40,-9 -44,-9 -69,0 -106,2 -112,7 -20,17 -29,25 -27,25 -4,0 -23,-8 -23,-13 0,-96 104,-136 184,-136 67,0 108,2 124,5 10,3 15,15 15,36z"
        id="path2287"
      />
      <path
        d="M-795 2273c0,34 -87,96 -261,186 -163,86 -260,129 -289,129 25,-56 105,-125 242,-209 132,-79 232,-123 300,-132 5,1 8,10 8,26z"
        id="path2289"
      />
      <path
        d="M-1005 1650c0,31 -9,49 -27,52 -15,-140 -29,-280 -44,-420 -18,-161 -37,-300 -58,-416l51 -90c52,305 78,596 78,874z"
        id="path2291"
      />
      <path
        d="M-1787 2320c0,35 -87,98 -261,188 -165,86 -261,129 -289,129 24,-56 105,-125 242,-208 132,-81 232,-125 299,-134 6,1 9,9 9,25z"
        id="path2293"
      />
      <path
        d="M-1689 1302c0,77 -29,116 -88,116 -21,0 -34,-5 -37,-14 -6,12 -19,24 -39,35 -21,10 -38,16 -53,16 -49,0 -74,-27 -74,-80 0,-38 11,-79 34,-122l47 0c0,7 -2,18 -8,32 -5,14 -7,25 -7,33 0,17 9,25 27,25 39,0 59,-35 59,-107l44 -30c-2,10 -3,32 -3,64 0,30 9,44 29,44 17,0 25,-26 25,-79l37 -29c5,67 7,99 7,96z"
        id="path2295"
      />
      <path
        d="M-1824 1109l-29 17c-4,-37 -17,-83 -41,-137 -24,-54 -48,-94 -73,-120l41 -110c68,21 102,118 102,291l0 59z"
        id="path2297"
      />
      <path
        d="M-4004 1729c0,25 -1,44 -2,56l-35 7c-1,-46 -10,-95 -26,-146 -20,-58 -45,-100 -74,-125l13 -134c39,23 70,75 93,156 21,68 31,130 31,186z"
        id="path2299"
      />
      <path
        d="M-3555 1101c0,8 -7,28 -21,61 -20,46 -55,79 -105,98 -47,15 -94,30 -142,46 -1,-6 -2,-9 -2,-9 0,-17 21,-39 63,-66 36,-22 66,-37 90,-45 -24,-7 -39,-11 -44,-11 -67,0 -104,3 -112,9 -1,1 -5,6 -12,13 -7,8 -12,12 -15,12 -2,0 -7,-2 -14,-6 -6,-4 -10,-7 -10,-9 0,-9 5,-25 16,-49 22,-56 79,-85 169,-85 66,0 108,2 123,5 11,3 16,15 16,36z"
        id="path2301"
      />
      <path
        d="M-3618 776c0,33 -75,87 -225,164 -94,46 -188,92 -281,137 -6,9 -18,14 -36,14l-8 -2c44,-99 196,-203 455,-310 51,-20 80,-30 87,-30l1 0c5,11 7,20 7,27z"
        id="path2303"
      />
      <path
        d="M-3063 1218c0,37 -9,75 -27,113 -21,47 -48,70 -81,70 -6,0 -15,-3 -29,-7 -17,24 -43,35 -79,35 -49,0 -73,-30 -73,-91 0,-80 20,-120 59,-120 5,0 8,3 9,10 1,3 1,10 0,19 -1,10 -2,15 -2,15 0,37 11,56 32,56 32,0 48,-37 48,-110l25 -29c8,1 14,17 18,48 4,31 13,47 28,47 20,0 30,-28 30,-83l36 -22c4,9 6,25 6,49z"
        id="path2305"
      />
      <path
        d="M-2922 811c0,34 -74,90 -224,166 -94,47 -189,92 -282,137 -7,10 -19,14 -38,14l-6 -2c25,-55 110,-126 255,-213 140,-85 237,-127 290,-127 3,17 5,25 5,25z"
        id="path2307"
      />
      <path
        d="M-2417 2071c0,32 -10,49 -29,53 -15,-140 -30,-280 -44,-420 -18,-162 -37,-301 -58,-417l53 -91c52,322 78,613 78,875z"
        id="path2309"
      />
      <path
        d="M-7321 2418c0,-14 -3,-23 -7,-25 -58,8 -136,50 -235,127 -109,84 -163,155 -163,215l0 -12c18,-20 94,-72 229,-156 117,-71 176,-120 176,-149z"
        id="path2311"
      />
      <path
        d="M-6353 2357c0,14 -4,36 -13,66 -12,35 -22,53 -31,53 -13,0 -39,-12 -77,-35 -38,-23 -58,-40 -60,-51l2 0c1,-21 7,-42 18,-66 10,-23 24,-38 39,-46 82,34 122,60 122,79z"
        id="path2313"
      />
      <path
        d="M-6177 2320c0,14 -4,36 -11,66 -11,35 -21,53 -31,53 -13,0 -39,-12 -78,-35 -38,-23 -58,-40 -61,-52l2 0c0,-14 6,-36 17,-64 13,-33 26,-49 37,-49 8,0 31,12 69,35 38,24 56,39 56,46z"
        id="path2315"
      />
      <path
        d="M-5811 2540c0,26 0,45 -2,58l-35 7c-1,-47 -10,-95 -25,-146 -21,-59 -46,-100 -75,-125l14 -136c38,24 69,76 93,156 20,67 30,129 30,186z"
        id="path2317"
      />
      <path
        d="M-6825 940c0,8 -7,28 -20,61 -20,46 -55,79 -105,98 -48,15 -95,30 -143,46 -1,-6 -1,-8 -1,-8 0,-17 21,-39 64,-67 36,-23 66,-38 90,-45 -24,-7 -39,-10 -44,-10 -67,0 -104,2 -112,8 -1,1 -5,6 -13,14 -7,8 -12,11 -14,11 -4,0 -8,-2 -15,-5 -6,-4 -9,-8 -9,-10 0,-9 5,-25 15,-49 23,-56 79,-85 170,-85 70,0 111,2 123,6 9,2 14,14 14,35z"
        id="path2319"
      />
      <path
        d="M-4145 2720c0,35 -86,97 -260,188 -165,84 -262,127 -290,127 45,-100 197,-203 456,-310 50,-20 79,-31 86,-31l3 2c4,9 5,17 5,24z"
        id="path2321"
      />
      <path
        d="M-5086 788c-32,46 -217,130 -555,250 -266,95 -579,198 -940,308 -329,100 -515,152 -559,156l-15 -12c39,-50 110,-96 211,-135 21,-8 103,-34 248,-78 273,-86 546,-171 819,-256 505,-157 768,-235 791,-235l0 2z"
        id="path2323"
      />
      <path
        d="M-4673 2239c0,13 -4,35 -12,66 -10,35 -20,52 -30,52 -14,0 -40,-11 -78,-34 -38,-23 -59,-41 -61,-52l2 0c0,-17 6,-40 18,-69 13,-28 26,-43 39,-43 9,0 32,12 68,34 36,23 54,38 54,46z"
        id="path2325"
      />
      <path
        d="M-4778 1804c0,55 -13,108 -41,159 -30,57 -70,93 -118,107 -8,13 -12,35 -12,64 0,68 -43,142 -128,224 -85,82 -161,123 -229,123 -43,0 -91,-14 -144,-42 -53,-29 -92,-61 -115,-97l18 -17c21,22 77,32 168,32 56,0 130,-24 222,-72 100,-55 151,-107 151,-156 0,-16 -8,-33 -22,-51 -21,-27 -32,-42 -34,-46 4,-49 12,-82 24,-97 12,-15 39,-23 81,-23 27,0 54,-12 81,-36 27,-25 41,-50 41,-77 0,-68 -17,-169 -51,-302 -34,-133 -51,-232 -51,-296 0,-106 16,-159 47,-159l19 3c0,43 15,74 44,93 3,23 5,43 5,59 0,7 -3,17 -8,31 -6,13 -9,23 -9,27 0,61 10,152 31,274 20,122 30,214 30,275z"
        id="path2327"
      />
      <path
        d="M-5098 1181c0,37 -9,75 -27,113 -21,46 -49,69 -81,69 -6,0 -16,-2 -29,-6 -17,23 -43,35 -78,35 -50,0 -74,-30 -74,-91 0,-80 19,-120 59,-120 4,0 7,3 8,10 1,4 1,11 0,20 -1,10 -1,15 -1,15 0,36 10,54 32,54 31,0 47,-36 47,-110l26 -27c7,1 14,17 18,48 5,30 14,45 29,45 19,0 29,-27 29,-83l35 -22c5,12 7,28 7,50z"
        id="path2329"
      />
      <path
        d="M-4436 2002c0,30 -9,47 -29,51 -14,-140 -29,-280 -44,-420 -18,-162 -37,-301 -57,-417l52 -90c52,322 78,614 78,876z"
        id="path2331"
      />
      <path
        d="M-822 2086c-12,31 -47,46 -105,46 -69,0 -115,-20 -139,-61 -44,85 -101,146 -171,183 -55,28 -138,50 -249,64l0 -32c124,-47 249,-135 373,-262 0,-165 43,-247 130,-247 31,0 70,23 118,71 48,47 93,73 134,76l0 3c850,125 2005,190 3805,190 1216,0 2676,-113 3714,-244 34,-4 69,86 127,86 103,0 228,-55 228,-174l28 -17c6,17 10,50 10,98 0,13 31,31 42,31 73,0 98,-91 98,-149l36 -21c2,45 60,75 100,75 30,0 111,-19 111,-58 0,-74 -51,-205 -155,-392 -9,0 -19,9 -30,29 -11,20 -23,30 -36,30l-4 -2c24,-162 45,-244 63,-244l5 2c107,158 218,383 218,577 0,78 -46,190 -138,190 -61,0 -104,-36 -127,-108 -34,90 -73,162 -116,216 -48,5 -110,15 -150,-18 -31,57 -129,81 -188,81 -53,0 -106,-110 -108,-110 -950,142 -2632,286 -3885,286l0 0c-4,0 -8,0 -13,0 -4,0 -8,0 -12,0l0 0c-1567,10 -3466,-108 -3714,-195zm-119 -128c0,-41 -11,-61 -33,-61 -15,0 -31,8 -49,25l82 36z"
        id="path2333"
      />
      <path
        d="M-907 402c0,54 -26,104 -78,150 -51,47 -105,70 -159,70 -20,0 -43,-7 -70,-21 -27,-15 -45,-22 -57,-22 -13,0 -28,14 -44,40 -16,27 -31,41 -45,42 3,-41 20,-81 51,-120 31,-39 67,-58 106,-58 19,0 42,5 68,15 25,-34 49,-68 74,-103 34,-39 70,-58 107,-58 13,0 25,7 34,21 9,15 13,29 13,44zm-91 28c-18,2 -37,11 -58,30 -20,19 -32,38 -37,57 2,1 5,1 7,1 27,0 46,-4 56,-13 21,-20 32,-45 32,-75z"
        id="path2335"
      />
      <path
        d="M-1423 1944c0,61 -5,106 -14,136 -15,52 -46,78 -93,78 -39,0 -75,-14 -106,-42 -32,-28 -54,-61 -65,-99 -8,44 -30,82 -66,114 -36,33 -76,49 -120,49 -68,0 -120,-39 -158,-116 -16,31 -57,46 -120,46 -83,0 -125,-20 -125,-59 0,-116 85,-206 254,-268l-3 -61c10,-12 20,-25 30,-39 10,-13 15,-27 15,-40 12,78 23,156 34,235 18,113 51,170 100,170 37,0 65,-19 85,-56 17,-30 25,-64 25,-104 0,-30 -4,-69 -12,-116 -10,-60 -16,-99 -18,-117 12,-13 22,-32 28,-58 7,-26 15,-44 22,-54 31,141 51,229 61,262 41,132 86,199 134,199 16,0 24,-29 24,-87 0,-27 -14,-81 -42,-161 -23,-67 -44,-121 -63,-161 9,-11 19,-31 29,-61 11,-29 22,-49 32,-61 7,31 33,109 79,234 35,98 53,177 53,237zm-647 -22c0,-13 -2,-25 -5,-35l-10 0c-45,0 -76,18 -92,54 0,3 -1,9 -3,17 0,1 -1,2 -2,3 0,9 4,17 12,25 8,7 17,11 26,11 49,0 74,-25 74,-75z"
        id="path2337"
      />
      <path
        d="M-4173 2159c-6,489 -579,734 -1650,734 -463,0 -1175,-131 -1520,-688l22 -14c525,410 1041,524 1581,524 759,0 1387,-145 1496,-434 -40,-87 -60,-156 -60,-206 0,-33 14,-64 43,-94l13 0c11,0 32,4 63,12 30,8 52,12 64,12l0 1c120,-3 190,-28 210,-74 37,-87 92,-150 164,-189 34,-18 117,-47 249,-87 -45,-31 -98,-47 -161,-47 -19,0 -56,3 -111,8 -48,5 -86,6 -115,4 13,-114 66,-171 159,-171 67,0 167,21 298,62 136,43 239,66 308,70l-53 123c-53,3 -114,8 -182,17 -109,177 -163,326 -163,449 0,68 19,123 57,164 38,42 90,63 158,63 56,0 130,-24 222,-73 99,-53 149,-105 149,-156 0,-16 -9,-36 -27,-58 -18,-22 -27,-35 -27,-38 0,-46 7,-78 23,-95 15,-17 42,-25 82,-25 27,0 54,-12 81,-37 27,-24 41,-50 41,-77 0,-35 -24,-141 -70,-320 -50,-186 -86,-296 -110,-330 -16,29 -24,44 -24,44 0,47 11,121 33,220 22,100 33,175 33,227 0,33 -9,63 -27,90l2 -43c2,-60 -10,-147 -36,-259 -27,-117 -40,-203 -40,-259 0,-60 18,-89 56,-89 63,0 122,107 176,323 43,175 64,309 64,401 0,56 -13,109 -40,160 -31,57 -70,93 -119,106 -8,14 -12,35 -12,65 0,77 -45,155 -134,232 -90,76 -175,115 -255,115 -90,0 -161,-31 -214,-92 -53,-61 -79,-136 -79,-227 0,-131 52,-289 155,-474 -155,23 -260,61 -314,114 41,46 62,96 62,149 0,35 -6,65 -18,89 -15,33 -38,50 -70,50 -54,0 -109,-28 -166,-82 -13,41 -50,72 -110,95 -34,13 -69,24 -105,25 -28,1 -46,-3 -52,-10zm413 -210c0,-25 1,-59 -34,-59 -15,0 -42,11 -42,29 29,20 44,30 76,30z"
        id="path2339"
      />
      <path
        d="M-2321 823c0,47 -25,95 -74,145 -50,50 -98,75 -144,75 -27,0 -56,-7 -85,-21 -29,-14 -49,-21 -59,-21 -14,0 -29,13 -45,40 -16,26 -32,40 -47,41 5,-41 22,-80 51,-117 32,-40 67,-60 107,-60 22,0 45,5 68,15 24,-34 49,-69 74,-104 35,-38 71,-57 107,-57 13,0 25,7 34,21 9,14 13,29 13,43zm-91 27c-18,1 -38,12 -58,31 -20,19 -33,38 -37,57 2,2 5,2 8,2 58,0 87,-30 87,-90z"
        id="path2341"
      />
      <path
        d="M-4339 752c0,46 -25,95 -74,145 -49,50 -97,75 -145,75 -27,0 -55,-7 -84,-21 -30,-14 -50,-21 -61,-21 -14,0 -29,13 -44,40 -16,26 -31,40 -46,41 3,-40 20,-80 52,-119 31,-39 66,-59 105,-59 20,0 42,5 68,16 25,-34 50,-69 75,-104 35,-38 70,-57 106,-57 14,0 25,7 34,21 9,14 14,28 14,43zm-92 29c-18,1 -37,11 -57,30 -21,18 -33,37 -38,56 3,1 6,2 9,2 27,0 45,-4 54,-12 22,-19 32,-44 32,-76z"
        id="path2343"
      />
      <path
        d="M-5078 1705l-105 133c-17,2 -35,3 -54,3 -22,0 -56,-2 -101,-6 -44,-4 -77,-6 -97,-6 -72,0 -144,24 -217,73 -28,18 -81,62 -159,132 -54,49 -95,73 -122,73 -44,0 -86,-48 -125,-142 -120,111 -418,210 -641,210 -313,0 -435,-58 -502,-90l-93 47c-66,0 -111,-20 -137,-61 -70,136 -169,218 -295,247l0 -32c0,-11 37,-54 112,-130 44,-44 88,-88 134,-132 -2,-165 42,-247 132,-247 14,0 60,8 110,57 139,139 269,181 613,181 273,0 420,-61 589,-135 41,59 82,88 124,88 27,0 66,-16 118,-47 89,-56 141,-86 154,-92 68,-35 132,-55 193,-59 -79,-17 -167,-27 -264,-31 -165,-8 -249,-12 -254,-12 14,-114 67,-171 159,-171 83,0 202,24 359,70 166,48 289,75 369,79zm-2245 234c0,-28 -6,-47 -17,-56 -3,-2 -6,-3 -7,-3l-12 0c-15,0 -31,8 -47,24l83 35z"
        id="path2345"
      />
    </svg>
  )
}

export default Besmele
